import type { GeneratedWorkbook } from '../core/types';

function downloadWorkbook(workbook: GeneratedWorkbook) {
  const blob = new Blob([workbook.data], { type: workbook.mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = workbook.fileName;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

interface Props {
  compiled: GeneratedWorkbook | null;
  raw: GeneratedWorkbook | null;
}

export function DownloadPanel({ compiled, raw }: Props) {
  if (!compiled || !raw) return null;
  return (
    <section className="card download-card">
      <h2>Baixar planilhas</h2>
      <div className="button-row">
        <button className="primary" onClick={() => downloadWorkbook(compiled)}>
          Baixar folha compilada
        </button>
        <button onClick={() => downloadWorkbook(raw)}>Baixar batidas/auditoria</button>
      </div>
    </section>
  );
}
